<template>
  <main class="main main--has-floating-buttons grid--dense grid--min-height">
    <card title="Global Feature Toggles" cols="12">
      <hm-card-inner>
        <spinner-overlay v-if="value == null" />
        <hm-col v-else cols="12 6@desktop">
          <template v-if="value.featureStatus != null">
            <template v-for="it in Object.entries(value.featureStatus)">
              <template v-if="it[0] != 'Undefined'">
                <hm-input-toggle v-model="value.featureStatus[it[0]]"
                                 :key="it[0]"
                                 :label="`Feature: ${it[0]}`"
                                 :enabled-title="`${it[0]} (Enabled)`"
                                 :disabled-title="`${it[0]} (DISABLED)`"
                                 :name="it[0]" />
              </template>
            </template>
          </template>
        </hm-col>
      </hm-card-inner>
    </card>


  </main>
</template>


<script>
/* eslint func-names: 0 */

import { isEmpty, isNil, last, isFunction, sortBy, head, lowerCase } from 'lodash';
import uuid from 'uuid';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import FilterMixin from '@/mixins/FilterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmCardInner from '../../lib/layout/HmCardInner';
import LoadingWrapper from '../../lib/util/LoadingWrapper.vue';
import SpinnerOverlay from '../../lib/util/SpinnerOverlay.vue';
import HmInputToggle from '../../lib/inputs/HmInputToggle.vue';

export default {
  name: 'PageGlobalFeatureToggles',
  components: { HmInputToggle, SpinnerOverlay, LoadingWrapper, HmCardInner },
  mixins: [HotelmeisterMixin, FilterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'toggles',
      variable: 'value',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.globalFeatureToggle.get(this), this.value)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      value: null,
    };
  },

  computed: {
  },

  watch: {
  },

  mounted: function () {
  },

  created: function () {
    this.loadData();
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.globalFeatureToggle.get(this))
        .then((response) => {
          this.showMessages(response);
          this.value = response.data.data;
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageGlobalFeatureToggles.vue